import { cn } from '../../lib/cn';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md' | 'lg';

const variants: Record<Variant, string> = {
  primary: 'bg-accent text-accent-ink hover:brightness-110',
  secondary: 'bg-raised text-ink hover:brightness-95',
  ghost: 'bg-transparent text-ink hover:bg-raised',
  danger: 'bg-transparent text-danger hover:bg-raised',
};

const sizes: Record<Size, string> = {
  sm: 'h-9 px-3 text-small gap-1.5',
  md: 'h-11 px-4 text-body gap-2',
  lg: 'h-12 px-5 text-body gap-2',
};

export interface ButtonStyleProps {
  variant?: Variant;
  size?: Size;
  block?: boolean;
}

/** Flat, one fill, one corner radius across the app. */
export function buttonClass({ variant = 'primary', size = 'md', block = false }: ButtonStyleProps) {
  return cn(
    'inline-flex items-center justify-center rounded-xl font-medium whitespace-nowrap select-none',
    'transition-[transform,filter,background-color] duration-150 ease-out active:scale-[0.97]',
    'disabled:pointer-events-none disabled:opacity-50',
    '[&_svg]:size-[1.15em] [&_svg]:shrink-0',
    variants[variant],
    sizes[size],
    block && 'w-full',
  );
}
